
import { Component, Vue, Prop } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { CartItemCode } from "@/types/cart-item";
import Cookies from "cookies-js";

const { State } = namespace("Root");

@Component
export default class CartCategory extends Vue {
  @State("cart") cart: any;

  @Prop({ default: "unknown" })
  code!: string;

  nr_items = 0;
  activeString = "";

  created() {
    // let val = Cookies.get(CartItemCode[this.code].name.toString());
    // if (!val) {
    //   return;
    // }
    // this.nr_items = Number(val);
  }

  get name() {
    if (CartItemCode[this.code]?.name) {
      return CartItemCode[this.code].name;
    }
    return "";
  }

  onItemChanged() {
    this.cart.quoteId = -1;
    this.cart.saved = false;
    this.cart.persist();
  }

  /**
   * Decrise value of the item in the cart.
   */
  decreaseValue() {
    this.nr_items = this.cart.countByCode(this.code);
    if (this.nr_items > 0) {
      this.nr_items--;
      this.cart.replaceByCode(this.code, this.nr_items);
    }
    this.activate();
  }

  /**
   * Decrise value of the item in the cart.
   */
  increaseValue() {
    this.nr_items = this.cart.countByCode(this.code);
    if (this.nr_items < 6) {
      this.nr_items++;
      this.cart.replaceByCode(this.code, this.nr_items);
    }
    this.activate();
    this.onItemChanged();
  }

  /**
   * Adds item to the cart.
   */
  addItem() {
    this.cart.replaceByCode(this.code, this.nr_items);
    this.deactivate();
  }

  //TODO
  /**
   * Show what is covered info modal.
   */
  showWhatsCovered() {
    this.$router.push({
      name: `compare.${this.code}`,
    });
  }

  activate() {
    this.activeString = "show";
  }

  deactivate() {
    this.activeString = "";
  }

  selectedItemsChanged() {
    Cookies.set(this.code.toString(), this.nr_items, {
      expires: 30 * 60,
    });
  }
}
